import { render } from "./businesses-page.vue?vue&type=template&id=ceb8afc4&ts=true"
import script from "./businesses-page.vue?vue&type=script&lang=ts"
export * from "./businesses-page.vue?vue&type=script&lang=ts"

import "./businesses-page.vue?vue&type=style&index=0&id=ceb8afc4&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__